import { type ReportStatus } from "@avg/shared";
import { useT } from "../i18n/I18nContext";
import { reportStatusLabelI18n } from "../i18n";

const styles: Record<ReportStatus, string> = {
  DRAFT: "badge-neutral",
  SUBMITTED: "badge-warn",
  MANAGER_APPROVED: "badge-info",
  ADMIN_APPROVED: "badge-success",
  REJECTED: "badge-danger",
};

export function StatusBadge({ status }: { status: ReportStatus }) {
  const t = useT();
  return <span className={styles[status]}>{reportStatusLabelI18n(t, status)}</span>;
}
